import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
Vue.use(ElementUI)
import moment from "moment";
Vue.prototype.$moment = moment;
Vue.config.silent = true // 用于发布版本时屏蔽Vue控制台警告问题
Vue.prototype.$EventBus = new Vue()

router.beforeEach((to, from, next) => {
  if (to.path === '/singleSignOn' || to.path === '/error')  {
    next()
  } else {
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      next({path: '/singleSignOn'})
    }
  }
  // next()
})
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
